import { Link } from "react-router-dom";
import Image from "../../assets/images/p7.jpg";


const Index = () => {
  return (
    <>
      <article className="post-929 page type-page status-publish hentry">
        <div className="page-image focus-point-image">
          <figure className="image image-7349">
            <img fetchPriority="high" loading="lazy" style={{ objectPosition: '50% 50%' }} width={1920} height={1080}
              src={Image} srcSet={`
                   ${Image} 2048w,
               ${Image} 1440w,
                ${Image}  960w
                `} alt="partnership" />
          </figure>
        </div>
        <div className="content-wrapper-inner">
          <div className="entry-wrap">
            <div className="entry-content pull-up">
              <header>
                <div className="breadcrumb">

                  <span typeof="v:Breadcrumb"><a rel="v:url" property="v:title" href>Work with us</a></span>
                  <span className="delimiter">/</span>
                  <span className="current">Partnerships</span>
                </div>
                {/* .breadcrumbs */}
                <div className="item-title">
                  <h1 className="entry-title">Partnerships</h1>
                </div>
                <span className="item-date" />
                {/* <div className="entry-text-to-speech">
                  <div id="readspeaker_button1" className="rs_skip rs_preserve rs_href">
                    <a className="rsbtn_play cta-button cta-button-secondary cta-button-medium cta-button-icon-left text-uppercase" accessKey="L" title="Listen to this page using ReadSpeaker" href="//app-eu.readspeaker.com/cgi-bin/rsent?customerid=6465&lang=en_uk&readid=readSpeakerSection&url=https%3A%2F%2Fwww.light-for-the-world.org%2Four-work%2Four-approach%2Fpartnerships%3Fpage%26pagename%3Dour-work%2Four-approach%2Fpartnerships" onclick="readpage(this.href, 'readSpeakerControls'); return false;">
                      <i className="fa fa-play" />Listen
                    </a>
                  </div>
                  <div id="readSpeakerControls" className="rs_preserve rs_skip rs_addtools rs_splitbutton rs_exp" />
                </div> */}
              </header>
              <div className="subnav-mobile">
                <Link to="/our-work" className="toggle-subnav-mobile">
                  Our Work
                </Link>
                {/* <ul className="entry-subnav">
                  <li className="page_item page-item-883 page_item_has_children">
                    <a href="https://www.light-for-the-world.org/our-work/disability-inclusion/">Disability Inclusion</a>
                    <ul className="children">
                      <li className="page_item page-item-1392">
                        <a href="https://www.light-for-the-world.org/our-work/disability-inclusion/education/">Education</a>
                      </li>
                      <li className="page_item page-item-884">
                        <a href="https://www.light-for-the-world.org/our-work/disability-inclusion/fighting-for-the-rights-of-people-with-disabilities/">Rights for people with disabilities</a>
                      </li>
                      <li className="page_item page-item-896">
                        <a href="https://www.light-for-the-world.org/our-work/disability-inclusion/economic-empowerment/">Economic Empowerment</a>
                      </li>
                      <li className="page_item page-item-898">
                        <a href="https://www.light-for-the-world.org/our-work/disability-inclusion/humanitarian-action/">Humanitarian Action</a>
                      </li>
                    </ul>
                  </li>
                  <li className="page_item page-item-1740 page_item_has_children">
                    <a href="https://www.light-for-the-world.org/our-work/eye-sight/">Eye Health</a>
                    <ul className="children">
                      <li className="page_item page-item-850">
                        <a href="https://www.light-for-the-world.org/our-work/eye-sight/saving-eyesight/">Saving Eyesight worldwide</a>
                      </li>
                      <li className="page_item page-item-882">
                        <a href="https://www.light-for-the-world.org/our-work/eye-sight/neglected-tropical-diseases/">Neglected Tropical Eye Diseases</a>
                      </li>
                    </ul>
                  </li>
                  <li className="page_item page-item-1772 page_item_has_children">
                    <a href="https://www.light-for-the-world.org/our-work/project-countries/">Focus Countries</a>
                    <ul className="children">
                      <li className="page_item page-item-4597">
                        <a href="https://www.light-for-the-world.org/our-work/project-countries/burkina-faso/">Burkina Faso</a>
                      </li>
                      <li className="page_item page-item-4595">
                        <a href="https://www.light-for-the-world.org/our-work/project-countries/ethiopia/">Ethiopia</a>
                      </li>
                      <li className="page_item page-item-4591">
                        <a href="https://www.light-for-the-world.org/our-work/project-countries/kenya/">Kenya</a>
                      </li>
                      <li className="page_item page-item-4589">
                        <a href="https://www.light-for-the-world.org/our-work/project-countries/mozambique/">Mozambique</a>
                      </li>
                      <li className="page_item page-item-4593">
                        <a href="https://www.light-for-the-world.org/our-work/project-countries/southsudan/">South Sudan</a>
                      </li>
                      <li className="page_item page-item-4570">
                        <a href="https://www.light-for-the-world.org/our-work/project-countries/uganda/">Uganda</a>
                      </li>
                    </ul>
                  </li>
                  <li className="page_item page-item-901 page_item_has_children current_page_ancestor current_page_parent">
                    <a href="https://www.light-for-the-world.org/our-work/our-approach/">Our Approach</a>
                    <ul className="children">
                      <li className="page_item page-item-950">
                        <a href="https://www.light-for-the-world.org/our-work/our-approach/driving-change/">Driving change</a>
                      </li>
                      <li className="page_item page-item-929 current_page_item">
                        <a href="https://www.light-for-the-world.org/our-work/our-approach/partnerships/" aria-current="page">Partnerships</a>
                      </li>
                    </ul>
                  </li>
                </ul> */}
              </div>
              <section id="readSpeakerSection">
                <h2 className="wp-block-heading">Together, we are stronger</h2>
                <section className="paragraph">
                  <div className="paragraph__container">
                    <p>
                      Collaboration is at the heart of everything we do. Our
                      impact simply wouldn’t be possible without our
                      partners.&nbsp;
                    </p>
                  </div>
                </section>
                <section className="paragraph">
                  <div className="paragraph__container">
                    <p>
                      We partner with organisations that bring strengths that
                      complement our own so that together, we can make a
                      bigger and more lasting difference for more people. Our
                      partnerships are built around shared values and goals
                      that guide how we work together.&nbsp;
                    </p>
                  </div>
                </section>
                <section className="paragraph">
                  <div className="paragraph__container">
                    <p><strong>Get in touch</strong></p>
                  </div>
                </section>
                <section className="paragraph">
                  <div className="paragraph__container">
                    <p>
                      If you are an international organisation interested in
                      exploring collaboration with Gbemisola  Foundation, you
                      can contact us here:
                      <a href="mailto:partnerships@light-for-the-world.org" target="_blank" rel="noreferrer noopener"> info@gbemisolafoundation.org</a>&nbsp; &nbsp;
                    </p>
                  </div>
                </section>

                <section className="paragraph">
                  <div className="paragraph__container">
                    <p>
                      We are committed to strengthening local structures and
                      capacity, fostering local ownership and focusing on the
                      sustainability of our interventions.&nbsp;
                    </p>
                  </div>
                </section>
                <section className="paragraph">
                  <div className="paragraph__container">
                    <p>
                      Partnerships are crucial to achieving lasting systems
                      change. We believe in putting the people and communities
                      we work for at the centre of our work and co-creating
                      solutions with them. Our partnerships give a greater
                      voice to marginalised communities.&nbsp;
                    </p>
                  </div>
                </section>

                {/* <ul className="wp-block-list">
                  <li>
                    <a href="#" target="_blank" rel="noreferrer noopener">Federation of Ethiopian Associations of Persons with
                      Disabilities</a>
                    (FEAPD)&nbsp;&nbsp;
                  </li>
                  <li>
                    <a href="#" target="_blank" rel="noreferrer noopener">Ghana Federation of Disability Organisations</a>
                    (GFD)&nbsp;&nbsp;
                  </li>
                </ul> */}
                {/* <section className="paragraph">
                  <div className="paragraph__container">
                    <p>
                      We also work closely with OPDs at the international and
                      regional levels through the
                      <a href="https://www.internationaldisabilityalliance.org/" target="_blank" rel="noreferrer noopener">International Disability Alliance</a>
                      (IDA), the
                      <a href="https://africandisabilityforum.net/" target="_blank" rel="noreferrer noopener">African Disability Forum</a>
                      (ADF), and the
                      <a href="https://www.edf-feph.org/" target="_blank" rel="noreferrer noopener">European Disability Forum</a>
                      (EDF).&nbsp;
                    </p>
                  </div>
                </section> */}
              </section>
            </div>
          </div>
        </div>
      </article>
    </>
  );
};

export default Index;
